<template>
  <div class="exchangeEecord">
    <ul v-if="list.length>0" class="list_box">
      <li v-for="item in list" :key="item.giftId" class="flex">
        <img :src="item.giftImgs" alt="">
        <div class="info">
          <p class="fs-14 fw-5 info_title">{{item.giftName}}</p>
          <p class="fs-10 fw-4 info_getExactTime">兑换时间：{{formatDate(item.exchangeDate)}}</p>
          <p class="fs-10 fw-4 info_getExactTime">发货时间：{{item.deliverDateTime}}</p>
          <div class="flex f-jc-sb fs-10 fw-4 info_getExactTime">
            <div class="info_expressName">
              <span v-if="item.expressCompany">{{item.expressCompany}}：{{item.expressOrder}}</span>
            </div>
            <div class="btn-groups flex f-jc-sb">
              <span class="fs-10 fw-4 copy mr-10" @click="doCopy(item.expressOrder)">复制</span>
              <span v-if="item.status === 2" class="fs-10 fw-4 copy" @click="checkExpressHistory(item.expressOrder)">物流详情</span>
              <span v-else class="fs-10 fw-4 no-express">暂无单号</span>
            </div>
          </div>
        </div>
      </li>
    </ul>
    <h3 v-else>暂无兑换记录</h3>

    <div class="dh_btn" @click="toPage">返回首页</div>
    <div class="bt_text">
      <span>电话咨询热线：{{phone}}</span>
      <br />
      <span>服务时间：工作日 {{workTime}}</span>
    </div>
  </div>
</template>
<script>
import { Toast } from "vant";
import { toEntry, getExactTime } from "@/core/utils/utils";

export default {
  name: "exchangeEecord",
  data() {
    return {
      list: [],
      phone: "021-23106668",
      workTime: "10:00-12:00 13:30-17:30"
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      const firstBrandId = localStorage.getItem("firstBrandId");
      const firstBrandPhoneMap = {
        "73a35a75431d571292e9022092723ec8" : "15707023624", 
        "865bb6bf598be724455f914ac4fbba6c" : "17521160348/13917555784",
        "a38851d291d12afcb09cc5a1b3569a16" : "021-23106668"
      };

      const firstBrandWorkTimeMap = {
        "73a35a75431d571292e9022092723ec8" : "10:00-12:00 13:00-18:00",
        "865bb6bf598be724455f914ac4fbba6c" : "10:00-12:00 13:30-17:30",
        "a38851d291d12afcb09cc5a1b3569a16" : "10:00-12:00 13:30-17:30"
      };

      this.phone =  firstBrandId != null && firstBrandPhoneMap[firstBrandId] != null ? firstBrandPhoneMap[firstBrandId] : "021-23106668";
      this.workTime =  firstBrandId != null && firstBrandWorkTimeMap[firstBrandId] != null ? firstBrandWorkTimeMap[firstBrandId] : "10:00-12:00 13:30-17:30";
      const oUserInfo = JSON.parse(localStorage.getItem("oUserInfo") ?? "{}");

      // if(oUserInfo.seqNo==='null') return;

      this.$store
        .dispatch({
          type: "exchangeEecord/history",
          payload: oUserInfo,
        })
        .then((data) => {
          const { code, msg, result } = data;
          if (code === "0") {
            this.list = result.list;
          } else {
            this.$toast.fail(msg);
          }
        })
        .catch((e) => {
          this.$toast.fail("接口请求失败");
        });
    },
    formatDate(value) {
      return value ? getExactTime(value) : "";
    },
    toPage() {
      toEntry(this.$router);
    },
    doCopy(text) {
      this.$copyText(text).then(
        function (e) {
          Toast.success("复制成功");
          // console.log(e)
        },
        function (e) {
          Toast.fail("复制失败");
          console.log(e);
        }
      );
    },
    checkExpressHistory(expressNum) {
      this.$store.dispatch({
        type: "expressHistory/saveExpressNum",
        payload: { expressNum },
      });
      this.$router.push("/user/ExpressHistory");
    },
  },
  beforeDestroy() {
    localStorage.removeItem("exchangeList");
  },
};
</script>
<style lang="scss">
.exchangeEecord {
  padding-top: 20px;
  width: 100%;
  height: calc(100vh - 20px);
  background: linear-gradient(135deg, #dff7ee 0%, #bfefdb 100%);
  h3 {
    text-align: center;
    color: #fff;
  }
  .list_box {
    margin: 0 auto;
    width: 351px;
    height: calc(100vh - 170px);
    overflow-y: auto;
    > li {
      margin-bottom: 20px;
      width: 100%;
      height: 85px;
      background: url("https://frontassets.oss-cn-shanghai.aliyuncs.com/giftExchange/dhjlbg1.png")
        no-repeat center center;
      background-size: cover;
      color: #323232;
      .info {
        flex: 1;
        padding-right: 10px;
      }
      > img {
        margin: 10px 21px 0 7px;
        width: 65px;
        height: 65px;
      }
      .info_title {
        margin: 6px 0 3px 0;
        width: 200px;
        font-family: PingFangSC-Medium, PingFang SC;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .info_expressName {
        min-width: 130px;
      }
      .mr-10 {
        margin-right: 10px;
      }
      .copy {
        color: #41ba9e;
      }
      .no-express {
        color: #999999;
        cursor: not-allowed;
      }
    }
  }
  .dh_btn {
    margin: 20px auto 0 auto;

    width: 154px;
    height: 40px;
    background: #41ba9e;
    border-radius: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
  }
  .bt_text {
    margin-top: 20px;
    font-size: 11px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #41ba9e;
    line-height: 15px;
    text-align: center;
  }
  .bt_text {
    text-align: center;
    margin-top: 20px;
    font-size: 11px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #41BA9E;
    line-height: 20px;
  }
}
</style>

